module.exports = __webpack_public_path__ + "img/1532944318.0ff3fab5.jpg";